import React, { useState } from 'react';
import { css } from '@emotion/core';
import { FLEX_COLUMN, FLEX_ROW } from '../../layout/flexBox';
import { INPUT } from '../../forms/styles/input';
import { btnStyle } from '../../forms/styles/button';
import { useFormik } from 'formik';
import { FORM_COLUMN } from '../../forms/styles/form';
import { Str } from '../../localization/translationKeys';
import LocalInput from '../../localization/LocalInput';
import LocalBtn from '../../localization/LocalBtn';
import { loginFormValidation } from '../formValidations';
import { ERROR_MSG } from '../../forms/styles/messages';
import Msg from '../../localization/Msg';
import { FIELDSET_DEFAULT } from '../../layout/fieldSetStyle';
import { COLORS } from '../../globalStyle/colors';
import eyeOn from '../../assets/eye.png';
import eyeOff from '../../assets/eye-off.png';


const styles = {
  fieldset: FIELDSET_DEFAULT,
  form:     [FLEX_COLUMN, FORM_COLUMN],
  errorMsg: [FLEX_ROW, ERROR_MSG, css`align-items: center;`],
  input:    INPUT(),
  btn:      btnStyle.primary(COLORS.GREEN),
  pwImg:       {
    root:    css`
      height: 20px;
      width: 20px;
      margin: 55px 0 0 283px;
      position: absolute;
      background-size: 20px 20px;
      cursor: pointer;
    `,
    hide:    css`
      background-image: url(${eyeOff});
    `,
    show: css`
      background-image: url(${eyeOn});
    `,
  },
}

type Props = {
  className?: string;
  errorMsg: Str | string;
  onLoginAttempt: (username: string, password: string) => void;
  isLoggingIn: boolean;
  initialEmail?: string;
  initialPassword?: string;
}


const LoginForm = (props: Props) => {
  const { handleSubmit, handleChange, isValid, resetForm, values } = useFormik({
    initialValues:    {
      username: props.initialEmail ?? '',
      password: props.initialPassword ?? '',
    },
    onSubmit:         (values) => {
      props.onLoginAttempt(values.username, values.password);
      resetForm();
    },
    validationSchema: loginFormValidation,
    validateOnChange: false,
  });

  const [pwType, setType] = useState('password');
  const [pwHide, setHidden] = useState(true);

  const togglePWVisibility = () => {
    if (pwType==='password'){
      setHidden(false);
      setType('text');
    } else {
       setHidden(true);
       setType('password');
    }
  }  

  return (
    <div className={props.className}>
      <fieldset disabled={props.isLoggingIn} css={styles.fieldset}>
        <form onSubmit={handleSubmit} css={styles.form}>
          {
            (!!props.errorMsg || !isValid) && (
              <div css={styles.errorMsg}>
                <Msg str={!isValid ? Str.LoginFailure : props.errorMsg} />
              </div>
            )
          }
          <LocalInput
            placeholderTranslation={Str.Email}
            name='username'
            type='text'
            value={values.username}
            css={styles.input}
            onChange={handleChange}
            autoComplete='off'
          />
          <LocalInput
            placeholderTranslation={Str.Password}
            name='password'
            type={pwType}
            value={values.password}
            css={styles.input}
            onChange={handleChange}
            autoComplete='off'
          />
          <div css={[styles.pwImg.root, pwHide ? styles.pwImg.hide : styles.pwImg.show]} onClick={togglePWVisibility}/>
          <LocalBtn str={Str.LogIn} type='submit' css={styles.btn} />
        </form>
      </fieldset>
    </div>
  );
};


export default LoginForm;
